<template>
  <div class="view profile">
    <div class="container">
      <h1 class="h2">Mon compte</h1>

      <form
        v-if="logged"
        @submit.prevent="onSave"
        action="#"
        class="view-form"
      >
        <h2 class="h3">Mes informations</h2>
        <!-- <div :class="['field', 'field-radio', { 'has-error': sexError }]">
          <div v-for="sex in sexes" :key="`input-${sex.value}`" class="field-element" >
            <input :id="`sex-${sex.value}`" :checked="infos.sex === sex.value" :value="sex.value" type="radio" class="u-visually-hidden" @change="onInput(sex.value, 'sex')" >
            <label :for="`sex-${sex.value}`">{{ sex.label }}</label>
          </div>
          <span v-if="sexError" class="field-error">{{ sexError }}</span>
        </div> -->

        <template v-for="field in fields">
          <div
            v-if="field.type === 'select'"
            :key="`field-${field.name}`"
            class="field"
          >
            <label
              :for="`field-${field.name}`"
              class="field-label"
            >
              Pays
            </label>
            <selection
              :id="`field-${field.name}`"
              :options="countries"
              :selected="selectedCountry"
              :placeholder="'Pays'"
              :error="field.error"
              :canBeNull="false"
              @option="onOptionCountry($event)"
            />
          </div>
          <field
            v-else
            :key="`field-${field.name}`"
            :id="`field-${field.name}`"
            :value="infos[field.name]"
            :label="field.label"
            :required="field.required || false"
            :error="field.error"
            @input="onInput($event, field.name)"
          />
        </template>

        <div class="view-form-actions">
          <btn
            :theme="'dark'"
            :type="'submit'"
          >
            Sauvegarder les modifications
          </btn>
        </div>
      </form>

      <div class="view-tickets">
        <h2 class="h3">Mes commandes</h2>

        <div class="view-tickets-field">
          <label
            for="tickets-reminder"
            class="view-tickets-field-label"
          >
            Me rappeler mes spectacles
          </label>
          <toggle
            :id="'tickets-reminder'"
            :checked="reminder"
            @change="onChangeReminder"
          />
        </div>

        <btn
          :theme="'dark'"
          @click="$router.push('/orders')"
        >
          Mes commandes
        </btn>
      </div>
    </div>

    <div class="view-footer">
      <div class="container">
        <btn
          :theme="'dark'"
          @click="onLogout"
        >
          Se déconnecter
        </btn>

        <p class="text">Pour supprimer votre compte, veuillez cliquer sur le lien ci-dessous. Dès confirmation de la suppression par mail, vos données seront effacées de notre base de données</p>

        <btn
          :theme="'transparent'"
          @click="onDelete"
        >
          Supprimer mon compte
        </btn>
      </div>
    </div>

    <div v-if="loading" class="loader-backdrop">
      <loader />
    </div>
  </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';
import Toggle from '@/components/components/Toggle.vue';
import Loader from '@/components/components/Loader.vue';
import Field from '@/components/modules/Field.vue';
import Selection from '@/components/components/Selection.vue';
// Data
import profile from '@/data/static/profile.json';
import countries from '@/data/static/countries.json';

export default {
  components: {
    Btn,
    Toggle,
    Field,
    Loader,
    Selection
  },
  beforeMount() {
    if (!this.$store.state.login.logged) {
      this.$store.commit('login/updateRedirect', '/profile');
      this.$router.push('/login');
    }
  },
  data() {
    return {
      sexes: [...profile.sex.answers],
      fields: [...profile.fields],
      sexError: null,
      countries
    };
  },
  computed: {
    logged() {
      return this.$store.state.login.logged;
    },
    infos() {
      return this.$store.state.profile.infos;
    },
    loading() {
      return this.$store.state.profile.requests !== 0;
    },
    selectedCountry() {
      const { country } = this.$store.state.profile.infos;
      if (!country) {
        return null;
      }

      const selected = this.countries.filter(c => c.value === country.toUpperCase());

      if (selected && selected.length > 0) {
        return selected[0];
      }

      return null;
    },
    reminder() {
      return this.$store.state.profile.pref.reminder;
    }
  },
  methods: {
    validate() {
      let valid = true;

      // Fields
      this.fields.map(field => {
        if (field.required) {
          const value = this.infos[field.name];
          if (!value || value.length === 0) {
            // eslint-disable-next-line
            field.error = 'Ce champ est requis';
            valid = false;
          } else {
            // eslint-disable-next-line
            if (field.validation) {
              const regex = new RegExp(field.validation.regex, 'i');
              const match = regex.test(value);

              if (match) {
                field.error = null;
              } else {
                field.error = field.validation.message;
                valid = false;
              }
            } else {
              field.error = null;
            }
          }
        }

        return field;
      });

      return valid;
    },
    // Events
    onInput($event, type) {
      this.$store.commit('profile/updateInfo', {
        value: $event,
        type
      });
    },
    onOptionCountry($event) {
      let e = $event;
      if (!e) {
        e = {
          value: ''
        };
      }

      this.$store.commit('profile/updateInfo', {
        value: e.value.toLowerCase(),
        type: 'country'
      });
    },
    onChangeReminder() {
      this.$store.commit('profile/updatePref', {
        type: 'reminder',
        value: !this.$store.state.profile.pref.reminder
      });

      this.$store.dispatch('profile/savePref');
    },
    onSave() {
      const valid = this.validate();

      if (valid) {
        this.$store.dispatch('profile/update');
      }
    },
    onLogout() {
      this.$store.dispatch('login/logout');
      this.$store.dispatch('profile/logout');
    },
    onDelete() {
      window.location.href = "mailto:billetterie@theatredeliege.be?subject=Suppression de mon compte&body=Bonjour, j'aimerais supprimer mon compte.";
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  position: relative;

  .h3 {
    @include margin(null null 33px);
    @include padding(null null 20px);
    border-bottom: 1px solid $grey-light-alternate;
  }

  // Form / information
  // -----------------------------------------------------------------------------
  &-form {
    @include margin(null null 32px);

    &-actions {
      @include margin(24px null null);

      .btn {
        color: $primary;

        &[disabled] {
          opacity: 1;
          color: rgba($primary, .5);
        }
      }
    }
  }

  .field {
    + .field {
      @include margin(16px null null);
    }

    &-label {
      @include padding(null null 9px);
      @include font('primary', 'bold');
      display: block;
      font-size: rem(18px);
      line-height: 1;
    }

    &.field-radio {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;

      &.has-error {
        .field-element label {
          color: $primary;
        }
      }

      + .field {
        @include margin(40px null null);
      }

      .field-element {
        input:checked {
          + label {
            &::after {
              opacity: 1;
            }
          }
        }

        label {
          @include padding(null null null 24px);
          @include font('secondary', 'regular');
          display: block;
          position: relative;
          font-size: rem(18px);
          line-height: 1;

          &::before {
            @include position(absolute, 0 null null 0);
            @include size(16px);
            content: '';
            border-radius: 50%;
            background-color: $grey-light-alternate;
          }

          &::after {
            @include position(absolute, 0 null null 0);
            @include size(16px);
            content: '';
            border: 5px solid $black;
            border-radius: 50%;
            opacity: 0;
            background-color: $white;
          }
        }
      }

      .field-error {
        @include padding(4px null null);
        width: 100%;
        font-size: rem(14px);
        color: $primary;
      }
    }
  }

  .btn {
    @include padding(16px null 15px);
    width: 100%;
  }

  // Tickets
  // -----------------------------------------------------------------------------
  &-tickets {
    h2 {
      + .btn {
        margin-top: 0;
      }
    }

    &-field {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-label {
        @include font('secondary', 'regular');
        font-size: rem(16px);
        line-height: 1;
      }
    }

    .btn {
      margin-top: 16px;
    }
  }

  // Footer
  // -----------------------------------------------------------------------------
  &-footer {
    @include padding(32px null 20px);
    margin-top: 40px;
    border-bottom: 1px solid rgba($white, .1);
    background-color: $black-light;

    .btn {
      &.dark {
        background-color: $black;
        border-color: $black;
        color: $white;
      }

      &.transparent {
        margin-top: 10px;
      }
    }

    .text {
      @include padding(20px null null);
      @include margin(20px null null);
      font-size: rem(12px);
      line-height: 1.5;
      border-top: 1px solid rgba($grey-light-alternate, .1);
    }
  }

  // Loader
  // -----------------------------------------------------------------------------
  .loader-backdrop {
    @include position(absolute, 0 null null 0);
    @include size(100%);
    z-index: 1;
    background-color: rgba($grey-light, .6);
  }

  .loader {
    @include position(fixed, calc(50% - 30px) null null calc(50% - 30px));
  }
}
</style>
